import React from 'react';
interface InputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
  id?: string;
}
export const Input = ({
  label,
  type = 'text',
  placeholder = '',
  value,
  onChange,
  required = false,
  error,
  id
}: InputProps) => {
  return <div className="mb-4" data-id="element-24">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-25">
        {label} {required && <span className="text-red-500" data-id="element-26">*</span>}
      </label>
      <input id={id} type={type} placeholder={placeholder} value={value} onChange={onChange} required={required} className={`w-full px-3 py-2 border ${error ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500`} data-id="element-27" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-28">{error}</p>}
    </div>;
};